import i18n from './../../i18n'

export default {
  namespaced: true,
  state: {
    language: localStorage.getItem('language')
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      localStorage.setItem('language', lang)
      state.language = lang
      i18n.locale = lang
    }
  },
  actions: {
    setLanguage({ commit }, languages) {
      if (typeof languages === 'string') {
        commit('SET_LANGUAGE', languages)
      } else {
        commit('SET_LANGUAGE', process.env.VUE_APP_I18N_FALLBACK_LOCALE)
      }
    },
    initLanguage({ commit }) {
      const language = localStorage.getItem('language')
      if (language) {
        commit('SET_LANGUAGE', language)
        return
      }
      commit('SET_LANGUAGE', process.env.VUE_APP_I18N_FALLBACK_LOCALE)
    }
  },
  getters: {
    getLanguage: state => {
      return state.language
    }
  }
}
